@let archive =
  archiveEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal() ??
  archiveEc.plugins.currentEntityPlugin.feature.selectors
    .getEntity()
    .asSignal();
@if (layoutStore.presentConfiguratorSg() && archive) {
  <!-- NOTE: nullish coalescing to avoid 'undefined' -->
  @let name = 'Configure AI resources for ' + (archive.name ?? '');
  <atn-ds-slideout-overlay
    [name]="name"
    (backdropClick)="layoutStore.patchState({ presentConfigurator: false })"
  >
    <div
      class="atn-summit-archive-configurator__actions"
      actions
    >
      <i
        class="atn-icon atn-close atn-red"
        (click)="layoutStore.patchState({ presentConfigurator: false })"
      ></i>
    </div>
    <div class="atn-summit-archive-configurator">
      <div class="atn-summit-archive-configurator__body">
        <atn-ds-select-multiple
          (refetch)="refetchEmployeeItemsHandler()"
          [value]="archive.employees ?? []"
          (valueChange)="selectedEmployeeIdsChangeHandler($event)"
          [error]="employeeItemsError.asSignal()"
          [items]="employeeItems.asSignal()"
          [loading]="employeeItemsLoading.asSignal()"
          label="Employees"
        />
        <atn-ds-text-area
          [value]="archive.instructions"
          (valueChange)="
            archiveEc.currentValueChangeHandler(
              'Summit.Archive.Configurator',
              'instructions',
              $event
            )
          "
          label="Instructions"
        />
      </div>
    </div>
  </atn-ds-slideout-overlay>
}
